import { render, staticRenderFns } from "./SpacesEditor.vue?vue&type=template&id=3241d83c&scoped=true"
import script from "./SpacesEditor.js?vue&type=script&lang=js&external"
export * from "./SpacesEditor.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditor.scss?vue&type=style&index=0&id=3241d83c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3241d83c",
  null
  
)

export default component.exports